module.exports = __webpack_public_path__ + "img/lashousuo.132cc911.png";